<template>
  <div class="plan">
    <page-banner title="系统方案" content="拥有多种智慧校园教育装备系统方案"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
        <v-breadcrumb-item to="/system_scheme">系统方案</v-breadcrumb-item>
        <v-breadcrumb-item :to="'/system_scheme/'+$route.params.id">{{plan.data.title}}</v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div class="plan_content">
      <div
        style="width:750px;display:inline-block;padding-right:35px;box-sizing: border-box;border-right:1px solid #eee;"
      >
        <div class="do-article-title">
          <h1 class="article-title">{{plan.data.title}}</h1>
          <div class="do-bar">
            <p>发布时间：{{plan.data.date}}</p>
          </div>
        </div>
        <div v-html="plan.data.content"></div>
        <el-divider></el-divider>
      </div>
      <div style="width:235px; float:right;height:100%;display:inline-block;"></div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>
<style scoped>
.plan {
  width: 100%;
  height: 100%;
  min-height: 800px;
}
.plan_content {
  width: 1000px;
  height: 100%;
  margin: 25px auto;
}
.do-bar {
  font-size: 13px;
  padding: 20px 0px;
  color: #888;
}
.article-title {
  font-weight: 400;
}
</style>
<script>
export default {
  name: "plan",
  data() {
    return {
      plan: {}
    };
  },
  watch: {
    /** 监听路由，放置已经加载此页面，再次更换url参数不会发生变化 */
    $route() {
      var _this = this;
      var id = this.$route.params.id; //采用了动态路由,通过this.$route.params.xx获取url的参数
      $.ajax({
        url: "/plan_id.php?id=" + id,
        type: "get",
        data: "",
        success: function(data, textStatus, jqXHR) {
          _this.plan = JSON.parse(data);
          console.log(_this.plan);
        }
      });
    }
  },
  mounted() {
    var _this = this;
    var id = this.$route.params.id; //采用了动态路由,通过this.$route.params.xx获取url的参数
    $.ajax({
      url: "/plan_id.php?id=" + id,
      type: "get",
      data: "",
      success: function(data, textStatus, jqXHR) {
        _this.plan = JSON.parse(data);
        console.log(_this.plan);
      }
    });
  }
};
</script>





// WEBPACK FOOTER //
// src/components/showPlan.vue